import React, { useState, useEffect, memo, useMemo } from 'react';
import Header from '../../layout/Header';
import { GENCREST_COLUMNS } from './column';
import { ARJUN_OIL_COLUMNS } from './arjunOilColumn';
import ArjunOilPaginated from './ArjunOilPaginated';
import TransactionViewModal from './TransactionViewModal';
import { Link } from 'react-router-dom';
import { getDynamicdata } from '../../../services/services';
import { getAllTrasaction } from '../../../services/auth';
import { decrypt } from '../../../utils/encodingdecoding';
import { MERCHANT_USER_TYPES } from '../../../utils';
import moment from 'moment';

const PAGE_SIZE = 50;

const ArjunOilTransactionList = memo(
    () => {
        const [data, setData] = useState([]);
        const [transactionCount, setTransactionCount] = useState();
        const [loader, setLoader] = useState(true);
        const [transaction, setTransaction] = useState([])
        const [pageIndex, setPageIndex] = useState(1);
        const [showViewModal, setShowViewModal] = useState(false);
        const [transactionId, setTransactionId] = useState('');
        const userType = decrypt(localStorage.getItem('userType'));
        const isArjunOils = userType === MERCHANT_USER_TYPES.ARJUN_OILS;
        const columns = isArjunOils ? ARJUN_OIL_COLUMNS : GENCREST_COLUMNS;

        useEffect(() => {
            fetch(pageIndex);
            // eslint-disable-next-line
        }, [pageIndex]);

        useEffect(() => {
            const ShortDataArjunOil = () => {
                const tempData = transaction?.transactions || [];

                if (!Array.isArray(tempData)) {
                    setData([]);
                    return;
                }

                const formatted = tempData.map((val) => {
                    return {
                        name: val?.customer?.[0]?.name || val?.customer?.name || "-",
                        mobile: val?.customer?.[0]?.mobile || val?.customer?.mobile || "-",
                        activity: val?.transactionDetail?.activity,
                        rewardpoint:val?.transactionDetail?.rewardpoint,
                        location:val?.transactionDetail?.location?.address,
                        transactionProcessedDate: val?.transactionProcessedDate
                            ? moment(val.transactionProcessedDate).format("DD-MMM-YYYY")
                            : "-",
                        action: (
                            <Link
                                to=''
                                className='edit_btn'
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleViewModal(val?.transactionId);
                                }}
                            >
                                <i className='fa-solid fa-eye'></i>
                                View Details
                            </Link>
                        ),
                    };
                });

                setData(formatted);
            };

            const ShortData = () => {
                const tempData = transaction?.data || [];

                if (!Array.isArray(tempData)) {
                    setData([]);
                    return;
                }

                const formatted = tempData
                    .map((item) => {
                        const req = item?.requestData;

                        if (!req?.customer) return null;

                        return {
                            firstName: req?.customer?.name || "-",
                            mobile: req?.customer?.mobile || "-",
                            totalAmount: req?.payment?.totalAmount || "-",
                            transactionDate: req?.transactionDate
                                ? moment(req.transactionDate).format("DD-MMM-YYYY")
                                : "-",
                            upiId: req?.payment?.upiId || "-",
                            upiName: req?.payment?.upiName || "-",
                            bankName: req?.payment?.bankName || "-",
                            accountNumber: req?.payment?.accountNumber || "-",
                            ifscCode: req?.payment?.ifscCode || "-",
                            beneficiaryName: req?.payment?.beneficiaryName || "-",
                            action: (
                                <Link
                                    to={`/customer-view/${req?.customer?.customerCode}`}
                                    state={{
                                        customerCode: req?.customer?.customerCode,
                                    }}
                                    className='edit_btn'
                                >
                                    <i className='fa-solid fa-eye'></i>
                                    View Details
                                </Link>
                            ),
                        };
                    })
                    .filter(Boolean);

                setData(formatted?.reverse());
            };

            userType === MERCHANT_USER_TYPES.ARJUN_OILS ? ShortDataArjunOil() : ShortData();
        }, [transaction]);

        const fetch = async (page) => {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem('token_gen'));
            let id = localStorage.getItem('Id');
            if (isArjunOils) {
                const res = await getAllTrasaction(token?.access_token, id, page, PAGE_SIZE);
                setTransaction(res);
            } else {
                const res = await getDynamicdata(token?.access_token, "", "")
                setTransaction(res)
            }
            setLoader(false);
        }

        useEffect(() => {
            setTransactionCount(transaction?.totalCount);
        }, [transaction]);

        const handleViewModal = (id) => {
            setTransactionId(id);
            setShowViewModal(true);
        };

        return (
            <>
                <Header
                    name={'Transaction'}
                />
                {loader && (
                    <div className='mainPreloaderMain'>
                        <div className='mainPreloader'>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                )}
                <div className='dashboard__content'>
                    <div className='container-fluid'>
                        <div className='dashboard__transactionsCard'>
                            <div className='dashboard__header'>
                                <div className='dashboard__left'>
                                    <h4 id='transction_list'>
                                        All Transactions
                                    </h4>
                                </div>
                            </div>
                            <div className='dashboard__body'>
                                    <ArjunOilPaginated
                                        data={data}
                                        columns={columns}
                                        pageIndex={pageIndex}
                                        pageCount={Math.ceil((transactionCount || 0) / PAGE_SIZE)}
                                        totalCount={transactionCount}
                                        onPageChange={setPageIndex}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
                {showViewModal && (
                    <TransactionViewModal
                        show={showViewModal}
                        close={() => setShowViewModal(false)}
                        transactionId={transactionId}
                    />
                )}
            </>
        );
    },
);


export default ArjunOilTransactionList
